import {useCallback} from 'react';
import type {Guidebook} from '@chekin/core';
import {PATHS} from 'routes/constants';
import {useSummary} from 'context/summary';
import {useFetchGuidebooks} from 'hooks/guidebooks/useFetchGuidebooks';
import {useGuidebookNavigate} from 'hooks/guidebooks/useGuidebookNavigate';
import {POSTHOG_EVENTS, useAnalytics} from 'analytics';

export function useHomeGuidebooks() {
  const {track} = useAnalytics();
  const {reservationId} = useSummary();
  const {data} = useFetchGuidebooks({reservationId});
  const {navigateToGuidebook} = useGuidebookNavigate(PATHS.guidebook);

  const guidebooks = data?.items ?? [];

  const openGuidebook = useCallback(
    (guidebook: Guidebook, source: string) => {
      track(POSTHOG_EVENTS.HOME_NAVIGATION, {source, destination: 'guidebook'});
      navigateToGuidebook(guidebook, guidebook.guidebook_group_id);
    },
    [navigateToGuidebook, track],
  );

  return {guidebooks, openGuidebook};
}
